const callbackTimeout = 400;

export const EmitEvent = ({ eventCategory, eventAction, eventLabel }) => {
  return new Promise((resolve, reject) => {
    if (typeof ga === undefined) {
      reject();
    }

    /** Timeout that resolves if callback is late or not firing */
    const timeout = setTimeout(() => {
      resolve();
    }, callbackTimeout);

    const [tracker] = ga?.getAll?.() ?? [];
    
    tracker?.send('event', eventCategory, eventAction, eventLabel, {
      hitCallback: () => {
        clearTimeout(timeout);
        resolve();
      },
    });
  });
};

export const EmitGoogleTagManagerConversionEvent = async (customName, dataLayerVariables = {}) => {
  try {
    await EmitGoogleTagManagerEvent('leazard-ping', 2500);

    return customName
      ? await EmitGoogleTagManagerEvent(`lead-form-submit-${customName}`, 10000, dataLayerVariables)
      : await EmitGoogleTagManagerEvent(`lead-form-submit`, 10000, dataLayerVariables);
  } catch (e) {
    console.log(JSON.stringify(e, null, 2));
  }
};

export const EmitGoogleTagManagerEvent = async (event, timeout, dataLayerVariables = {}) => {
  return new Promise((resolve, reject) => {
    try {
      if (!window.dataLayer) {
        throw new Error('GTM not configured');
      }

      setTimeout(() => {
        reject('Timeout occurred');
      }, timeout);

      window.dataLayer.push({
        event,
        ...dataLayerVariables,
        eventTimeout: timeout,
        eventCallback: () => {
          resolve();
        },
      });
    } catch (e) {
      reject(e);
    }
  });
};
